import { useLayoutEffect, useRef } from 'preact/hooks';

export const SHORTCUTS: Array<[string, string]> = [
  ['Drag / one finger', 'Rotate the body'],
  ['Scroll / pinch', 'Zoom'],
  ['Right-drag / two fingers', 'Pan'],
  ['Click / tap', 'Select a part'],
  ['Double-click', 'Orbit around that point'],
  ['← → ↑ ↓', 'Rotate'],
  ['+ / −', 'Zoom in / out'],
  ['R', 'Reset the view'],
  ['F', 'Centre the selected part'],
  ['I', 'Isolate the selected part'],
  ['H', 'Hide the selected part'],
  ['P', 'Peel the next layer'],
  ['Esc', 'Close a dialog, then show all / deselect'],
  ['← → / Space', 'In a tour: previous / next stop'],
  ['Page Up / Page Down', 'In a tour: previous / next stop (presentation clickers)'],
  ['Tab / Shift + Tab', 'Move between controls; Enter or Space to use them'],
  ['Ctrl/⌘ + Z', 'Undo (add Shift to redo)'],
  ['/', 'Search'],
  ['?', 'This help'],
];

export function HelpOverlay({ onClose }: { onClose: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  // Escape is handled by App's keyboard map (always registered); here we only move focus into the dialog.
  useLayoutEffect(() => {
    ref.current?.querySelector('button')?.focus();
  }, []);
  return (
    <div class="overlay" role="dialog" aria-modal="true" aria-labelledby="help-title" ref={ref} data-testid="help-overlay">
      <div class="dialog">
        <div class="dialog-head">
          <h2 id="help-title">Getting around</h2>
          <button type="button" class="btn ghost icon" aria-label="Close help" onClick={onClose}>×</button>
        </div>
        <dl class="shortcuts">
          {SHORTCUTS.map(([k, v]) => (
            <div key={k}>
              <dt><kbd>{k}</kbd></dt>
              <dd>{v}</dd>
            </div>
          ))}
        </dl>
        <p class="muted small">No 3D? Use the search box or <strong>Menu → Browse all parts</strong>: every part has a readable card.</p>
      </div>
    </div>
  );
}
